import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';

import { actions as productCatalogActions } from '../../../../store/ducks/product-catalog.duck';
import { IAppState } from '../../../../store/rootDuck';

export function useCatalogSearch() {
  const dispatch = useDispatch();
  const { categoryIdActive } = useSelector((store: IAppState) => ({
    categoryIdActive: store.productsCatalog.categoryIdActive,
  }));
  const [searchParams, setSearchParams] = useSearchParams();
  const category = searchParams.get('category');

  useEffect(() => {
    if (category) {
      dispatch(productCatalogActions.setCategoryIdActive(Number(category)));
    }
  }, []);

  useEffect(() => {
    if (categoryIdActive) {
      setSearchParams({ category: String(categoryIdActive) });
    } else {
        searchParams.delete('category');
    }
  }, [categoryIdActive]);

  const setCategory = (id: number) => {
    setSearchParams({ category: String(id) });
  };

  return { category: category ? Number(category) : null, setCategory };
}
